import { GetInitiativesRequest } from './getInitiatives';
import { InitiativeStatus } from '@types';
import { createPatchEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type PatchInitiativesBulkRequest = Partial<GetInitiativesRequest> & {
	initiativeIdsToExclude?: Array<number>;
	patchInitiativeDescription: {
		assignedTo?: number;
		initiativeStatusId?: InitiativeStatus;
	};
};

export const patchInitiativesBulk = createPatchEndpoint<PatchInitiativesBulkRequest>(
	({ initiativeIdsToExclude, patchInitiativeDescription, ...rest }) =>
		`/api/v3/initiatives/inverse-selection?${getQueryString(rest)}`,
	{
		requestTransform: ({ initiativeIdsToExclude, patchInitiativeDescription }) => ({
			initiativeIdsToExclude,
			patchInitiativeDescription
		})
	}
);
